import React, {useEffect} from 'react'
import UiInputText from "../components/Form/UiInputText";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';
import UiInputList from "../components/Form/UiInputList";
import UiInputCheckbox from "../components/Form/UiInputCheckbox";
import Overlay from "../components/Overlay";

const regimeList = [
    { id: 1, title: 'Simples Nacional' },
    { id: 2, title: 'Simples Nacional (excesso)' },
    { id: 3, title: 'Regime Normal' },
];

const ambienteList = [
    { id: 1, title: 'Produção' },
    { id: 2, title: 'Homologação' },
];

const toDefaults = (data: any) => {
    const base = { regimeTributario: 1, ambiente: 2, ativo: true, padrao: false };
    const cfg = (data && data.config) ? data.config : {};
    return {
        ...base,
        ...(data || {}),
        config: { ...cfg, ipm: { ...(cfg.ipm || {}) } },
    };
};

export default function EmitenteForm(props: any) {
    const methods = useForm({
        defaultValues: toDefaults(props.data),
        shouldUnregister: false,
    });
    const { handleSubmit, reset } = methods;

    useEffect(() => {
        if (props.data) {
            reset(toDefaults(props.data));
        }
    }, [props.data, reset]);

    if (props.loading) {
        return <Overlay show={true} />;
    }

    return (
        <FormProvider {...methods}>
            <Form onSubmit={handleSubmit(props.triggerSubmit)} methods={methods}>
                <WindowBody>
                    <div className="row">
                        <div className="col-12 col-lg-6">
                            <fieldset>
                                <legend>Emitente</legend>
                                <div className="row">
                                    <UiInputText size={12} name="razaoSocial" label="Razão Social"/>
                                    <UiInputText size={12} name="nomeFantasia" label="Nome Fantasia"/>
                                    <UiInputText size={6} name="cnpj" label="CNPJ"/>
                                    <UiInputText size={6} name="ie" label="Inscrição Estadual"/>
                                    <UiInputText size={6} name="im" label="Inscrição Municipal"/>
                                    <UiInputList size={6} name="regimeTributario" list={regimeList} idField="id" titleField="title" label="Regime" placeholder={false}/>
                                    <UiInputList size={6} name="ambiente" list={ambienteList} idField="id" titleField="title" label="Ambiente" placeholder={false}/>
                                    <UiInputCheckbox size={3} name="ativo" label="Ativo"/>
                                    <UiInputCheckbox size={3} name="padrao" label="Padrão"/>
                                </div>
                            </fieldset>
                        </div>

                        <div className="col-12 col-lg-6">
                            <fieldset>
                                <legend>NFS-e Município (IPM / Atende.net)</legend>
                                <div className="row">
                                    <UiInputText size={12} name="config.ipm.url" label="URL do serviço"/>
                                    <UiInputText size={6} name="config.ipm.login" label="Login"/>
                                    <UiInputText size={6} name="config.ipm.senha" label="Senha"/>
                                    <UiInputText size={4} name="config.ipm.cidade" label="Código Cidade"/>
                                    <UiInputText size={4} name="config.ipm.codigo_nbs" label="Código NBS"/>
                                    <UiInputText size={4} name="config.ipm.aliquota_iss" label="Alíquota ISS (%)"/>
                                    <UiInputText size={12} name="config.ipm.item_lista_servico" label="Item da Lista de Serviço"/>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </WindowBody>

                <WindowFooter>
                    <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                    <UiButton variant="primary" type="submit">Salvar</UiButton>
                </WindowFooter>
            </Form>
        </FormProvider>
    );
}
